import React from "react";
import { Box, Text, HStack, IconButton } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

export const FaqItem: React.FC<IFAQItem> = ({ data, index, onExpand }) => {
  const handleToogle = () => {
    if (typeof onExpand === "function") {
      onExpand(data, index);
    }
  };

  return (
    <Box
      key={index}
      w="100%"
      p={4}
      borderRadius="md"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
    >
      <HStack
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bg="gray.100"
        borderRadius="10px"
        pt={"5px"}
        pb={"5px"}
        width="100%"
        onClick={handleToogle}
      >
        <Text
          pl={"15px"}
          pr={"1px"}
          style={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {data?.question}
        </Text>
        <IconButton
          aria-label="Expand"
          icon={data?.isExpended ? <ChevronDownIcon /> : <ChevronUpIcon />}
          variant="ghost"
          size={"lg"}
        />
      </HStack>
      {data?.isExpended && (
        <Box mt={4} p={4} bg="#0BB4AF" borderRadius="20px">
          <Text
            color="white"
            size="14px"
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            {data?.answer}
          </Text>
        </Box>
      )}
    </Box>
  );
};
